import { Modal, Button } from "react-bootstrap";

const KycRejectedModal = ({ show, handleClose }) => {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Body className="text-center p-4">

        <svg
          width="70"
          height="70"
          viewBox="0 0 80 80"
          fill="none"
        >
          <circle cx="40" cy="40" r="28" stroke="rgba(255,46,46,0.3)" strokeWidth="2" />
          <circle cx="40" cy="40" r="20" fill="rgba(255,46,46,0.12)" />
          <path
            d="M48 32L32 48M32 32L48 48"
            stroke="#ff2e2e"
            strokeWidth="3"
            strokeLinecap="round"
          />
        </svg>


        {/* Title */}
        <h4 className="fw-bold text-danger mb-2">
          KYC Verification Failed
        </h4>

        {/* Message */}
        <p className="text-muted">
          Your KYC has been <strong>rejected</strong> by Rain.
        </p>

        <p className="text-muted">
          You are currently <strong>blocked</strong> from using this account.
          Please try again using a <strong>new account</strong>.
        </p>

        {/* Buttons */}
        <div className="d-flex justify-content-center gap-3 mt-4">
          <Button onClick={handleClose}>
            Close
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default KycRejectedModal;
